<div class="py-4">
  <py-campaign-extra-small-items
    infiniteScroll
    [infiniteScrollThrottle]="300"
    [infiniteScrollDistance]="2"
    [infiniteScrollDisabled]="infiniteScrollDisabled"
    [products]="extraSmallProductsList"
    [badgeType]="campaignBadgeType"
    [queryParams]="queryParams"
    (scrolled)="nextPage(currentPage + 1)"
  >
  </py-campaign-extra-small-items>
</div>
